import { POOLS_MAP } from "../constants"
import { Box, Container } from "@mui/material"
import { useWeb3React } from "@web3-react/core"
import React, { ReactElement } from "react"
import { usePollUserFerroBoost } from "src/state/xFer/hooks"
import BoostOverview from "../components/BoostOverview"
import PoolOverview from "../components/PoolOverview"
import styles from "./Pools.module.scss"
import Text from "src/components/Text"
import { useTranslation } from "react-i18next"
import { getChainId } from "src/utils"

function Pools(): ReactElement | null {
  const { t } = useTranslation()
  const chainId = getChainId()
  const { account } = useWeb3React()
  usePollUserFerroBoost(account)

  return (
    <Container>
      <div className={styles.poolsPage}>
        <Text variant="h2" textAlign="center" mt={3} mb={2}>
          {t("Pools")}
        </Text>
        <Box className={styles.content}>
          <BoostOverview />
          {Object.values(POOLS_MAP)
            .filter(({ addresses }) => (chainId ? addresses[chainId] : false))

            .map((pool) => (
              <PoolOverview key={pool.name} poolName={pool.name} />
            ))}
        </Box>
      </div>
    </Container>
  )
}

export default Pools
